"use strict";
// src/graphql/alphalend/client.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApiUrl = getApiUrl;
exports.getClient = getClient;
exports.setApiUrl = setApiUrl;
exports.setCustomClient = setCustomClient;
/* This file contains the setup for the Apollo Client, implemented as a singleton
 */
const core_1 = require("@apollo/client/core");
// Lazy initialization for the Apollo Client instance
let clientInstance = undefined;
let apiUrl = undefined;
/**
 * Get the current API URL.
 * If no URL has been set, it defaults to the AlphaLend API URL.
 */
function getApiUrl() {
    apiUrl = apiUrl
        ? apiUrl
        : process.env.ALPHALEND_GRAPHQL_URL || "https://api.alphalend.xyz/graphql";
    return apiUrl;
}
/**
 * Get the Apollo Client instance.
 * If a new URL has been set via setApiUrl, it will create a new instance with the updated URL.
 */
function getClient(url) {
    if (url) {
        setApiUrl(url);
    }
    if (!clientInstance) {
        const currentUrl = getApiUrl();
        clientInstance = new core_1.ApolloClient({
            link: new core_1.HttpLink({
                uri: currentUrl,
            }),
            cache: new core_1.InMemoryCache(),
        });
    }
    return clientInstance;
}
/**
 * Set a new API URL.
 * This will invalidate the current Apollo Client instance, ensuring that
 * the next call to getClient returns a new instance with the updated URL.
 *
 * @param url - The new API URL for the Apollo client.
 */
function setApiUrl(url) {
    if (apiUrl !== url) {
        apiUrl = url;
        clientInstance = undefined; // Invalidate the current instance to allow creating a new one
    }
}
/**
 * Set a custom Apollo Client instance.
 * This function directly assigns the provided Apollo Client instance to the global variable.
 *
 * @param client - The custom Apollo Client instance to be set.
 */
function setCustomClient(client) {
    clientInstance = client;
}
//# sourceMappingURL=client.js.map